import React, { useEffect } from "react";
import "./ScrollButtons.css"; // CSS file for styling

const ScrollButtons = () => {
  useEffect(() => {
    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const handleScrollToBottom = () => {
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
    };

    const topBtn = document.getElementById("topBtn");
    const bottomBtn = document.getElementById("bottomBtn");

    if (topBtn && bottomBtn) {
      topBtn.addEventListener("click", handleScrollToTop);
      bottomBtn.addEventListener("click", handleScrollToBottom);
    }

    return () => {
      if (topBtn && bottomBtn) {
        topBtn.removeEventListener("click", handleScrollToTop);
        bottomBtn.removeEventListener("click", handleScrollToBottom);
      }
    };
  }, []);

  return (
    <>
      <div id="bottomBtn" className="fas fa-arrow-down" data-hover="Go to Bottom"></div>
      <div id="topBtn" className="fas fa-arrow-up" data-hover="Go to Top"></div>
    </>
  );
};

export default ScrollButtons;
